import * as React from "react";

const SvgAdd = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path fill="currentColor" d="M12.267 6.667H10.4V10.4H6.667v1.867H10.4V16h1.867v-3.733H16V10.4h-3.733zM11.333 2a9.333 9.333 0 1 0 9.333 9.333A9.349 9.349 0 0 0 11.333 2zm0 16.8a7.467 7.467 0 1 1 7.467-7.467 7.477 7.477 0 0 1-7.467 7.467z" transform="translate(.667 .667)" /></svg>;

export default SvgAdd;